import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import msaLogo from "../../../images/msa-psg-logo_white.svg";
import { classNames } from "../../../utils/utils";
import { Link } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { formMappings } from "../../../config/formMappings";

export default function SideNavigation(props: {
  pathname: string;
  navItems: any[];
  activeFormName: string;
  handleFormSelect: (formKey: string) => void;
}) {
  return (
    <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
      <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-primary px-6 pb-4">
        <div className="flex h-16 shrink-0 items-center my-5">
          <img alt="MSA PSG" src={msaLogo} className="w-full" />
        </div>
        <nav className="flex flex-1 flex-col">
          <ul className="flex flex-1 flex-col gap-y-7">
            <li>
              <Menu as="div" className="relative inline-block w-full">
                <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring-1 inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20">
                  {props.activeFormName}
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="-mr-1 size-5 text-gray-400"
                  />
                </MenuButton>

                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg outline-1 outline-black/5 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10"
                >
                  <div className="py-1">
                    {Object.keys(formMappings).map((formKey) => {
                      const formMapping =
                        formMappings[formKey as keyof typeof formMappings];
                      return (
                        <MenuItem key={formKey}>
                          {({ close }) => (
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                props.handleFormSelect(formKey);
                                close();
                              }}
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:data-focus:bg-white/5 dark:data-focus:text-white transition-colors cursor-pointer"
                            >
                              {formMapping.formName}
                            </a>
                          )}
                        </MenuItem>
                      );
                    })}
                  </div>
                </MenuItems>
              </Menu>
            </li>
            <li>
              <ul className="-mx-2 space-y-1">
                {props.navItems.map((item) => {
                  const isRoot = item.href === "/";
                  const isActive = isRoot
                    ? props.pathname === "/"
                    : props.pathname.startsWith(item.href) && item.href !== "/";

                  return (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className={classNames(
                          isActive
                            ? "bg-secondary text-white"
                            : "text-indigo-200 hover:bg-secondary hover:text-white",
                          "group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                        )}
                      >
                        <item.icon
                          aria-hidden="true"
                          className={classNames(
                            isActive
                              ? "text-white"
                              : "text-indigo-200 group-hover:text-white",
                            "h-6 w-6 shrink-0"
                          )}
                        />
                        {item.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </li>
            <li className="mt-auto">
              <Link
                to="/settings"
                className={classNames(
                  props.pathname === "/settings"
                    ? "bg-secondary text-white"
                    : "text-indigo-200 hover:bg-secondary hover:text-white",
                  "group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                )}
              >
                <Cog6ToothIcon
                  aria-hidden="true"
                  className="h-6 w-6 shrink-0 text-indigo-200 group-hover:text-white"
                />
                Settings
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
